<script setup lang="ts">
import { computed } from "vue";
import { useGlobalModal } from "@/shared/composables/useGlobalModal";

const { modals, hideGlobalModal } = useGlobalModal();

const currentModal = computed(() => modals.value[modals.value.length - 1]);
const isOpen = computed(() => modals.value.length > 0);

const closeCurrentModal = () => {
    hideGlobalModal();
};
</script>

<template>
    <Teleport to="body">
        <Transition name="modal-fade">
            <div v-if="isOpen" class="modal-backdrop" @click="closeCurrentModal">
                <Transition name="modal-slide" appear>
                    <component
                        :is="currentModal.component"
                        v-if="currentModal.component"
                        v-bind="currentModal.props"
                        v-on="currentModal.events"
                        @close="closeCurrentModal"
                        class="modal"
                        :class="currentModal.modalClass" />
                </Transition>
            </div>
        </Transition>
    </Teleport>
</template>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.2s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-slide-enter-active,
.modal-slide-leave-active {
    transition: all 0.3s ease;
}

.modal-slide-enter-from,
.modal-slide-leave-to {
    opacity: 0;
    transform: scale(0.95);
}

.modal-backdrop {
    position: fixed;
    inset: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.75);
    padding: 1rem;
}

/* Base modal styles */
.modal {
    background: white;
    border-radius: 1rem;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    overflow: hidden;
    max-width: 28rem;
    width: 100%;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
}

/* Small modal (QR, etc) */
.modal.modal-sm {
    max-width: 24rem;
}

/* Fullscreen modal */
.modal.modal-fullscreen {
    position: fixed;
    inset: 0;
    max-width: 100%;
    width: 100%;
    max-height: 100%;
    height: 100%;
    border-radius: 0;
}

/* Mobile: always fullscreen */
@media (max-width: 640px) {
    .modal {
        position: fixed;
        inset: 0;
        max-width: 100%;
        width: 100%;
        max-height: 100%;
        height: 100%;
        border-radius: 0;
    }
}
</style>
